import { render, staticRenderFns } from "./CompanyEmployeeLeaveAssignmentForm.vue?vue&type=template&id=6290da6c&scoped=true&"
import script from "./CompanyEmployeeLeaveAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./CompanyEmployeeLeaveAssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290da6c",
  null
  
)

export default component.exports